export default {
    pmtags_main_title: 'Tags',
    pmtags_main_label: 'Label',
    pmtags_main_accounts: 'Accounts',
    pmtags_main_devices: 'Devices',
    pmtags_main_edit_tag: 'Edit',
    pmtags_main_delete_tag: 'Delete',
    pmtags_main_add_tag: 'Add Tag',
};